import { CircularProgress, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useState, useEffect, useContext } from "react";
import CrudService from "services/cruds-service";
import cover_letter_teaser_image from "assets/images/cover-letter-teaser.jpg";
import { useParams } from "react-router-dom";
import { AuthContext } from "context";
import MDEditor from "@uiw/react-md-editor";

const ApplyTab = ({ coverLetterLoader, job, generateCoverLetter }) => {
  return (
    <>
      <MDTypography variant="h6" fontWeight="medium" mt={1}>
        Apply Tab
      </MDTypography>
      <MDTypography variant="body2" mt={1}>
        Apply for the job by using this section to get the material you need to
        apply.
      </MDTypography>
      <MDBox
        key="cover_letter_block"
        display="block"
        color="text"
        borderRadius="xl"
        mt={2.5}
        py={1.875}
        px={1.875}
        lineHeight={1.5}
      >
        {coverLetterLoader ? (
          <MDTypography variant="h6" fontWeight="medium" mt={1}>
            <CircularProgress color="info" size={15} /> &nbsp; Generating Cover
            Letter
          </MDTypography>
        ) : (
          <>
            {job.cover_letter ? (
              <>
                <MDTypography variant="h6" fontWeight="medium" mt={1}>
                  {"Cover Letter"}
                </MDTypography>
                <MDBox>
                  <div data-color-mode="light">
                    <MDEditor.Markdown
                      source={job.cover_letter}
                      style={{ color: "#344767", background: "transparent" }}
                      components={{
                        p: ({ node, ...props }) => (
                          <p style={{ color: "#7b809a" }} {...props} />
                        ),
                      }}
                    />
                  </div>
                </MDBox>
              </>
            ) : (
              <>
                {/* Show teaser image and button to generate cover letter */}
                <MDBox>
                  <img
                    src={cover_letter_teaser_image}
                    alt="cover-letter-teaser"
                  />
                </MDBox>

                <MDButton
                  variant="contained"
                  color="info"
                  onClick={generateCoverLetter}
                >
                  Generate Cover Letter
                </MDButton>
              </>
            )}
          </>
        )}
      </MDBox>
    </>
  );
};

export default ApplyTab;
